export interface CompetitionsState {
    selectedTab: AvailableCompetitionTabs | null;
}

export const AvailableCompetitionTabs = {
    Matches: 'm',
    Outrights: 'or',
    Results: 'r',
    Insights: 'ig',
    Standings: 'st',
    Social: 'so',
} as const;
export type AvailableCompetitionTabs = typeof AvailableCompetitionTabs[keyof typeof AvailableCompetitionTabs];

/**
 * @generated from
 * https://s3-eu-west-1.amazonaws.com/public-data.staging.stats.superbet.k8s.local/common.proto
 */
export enum FeatureType {
    /**
     * @generated from enum value: FEATURETYPE_DETAIL = 0;
     */
    FEATURETYPE_DETAIL = 0,

    /**
     * @generated from enum value: FEATURETYPE_LINEUP = 1;
     */
    FEATURETYPE_LINEUP = 1,

    /**
     * @generated from enum value: FEATURETYPE_HEAD_TO_HEAD = 2;
     */
    FEATURETYPE_HEAD_TO_HEAD = 2,

    /**
     * @generated from enum value: FEATURETYPE_CUP = 3;
     */
    FEATURETYPE_CUP = 3,

    /**
     * @generated from enum value: FEATURETYPE_TABLE = 10;
     */
    FEATURETYPE_TABLE = 10,

    /**
     * @generated from enum value: FEATURETYPE_ATP_TABLE = 11;
     */
    FEATURETYPE_ATP_TABLE = 11,

    /**
     * @generated from enum value: FEATURETYPE_WTA_TABLE = 12;
     */
    FEATURETYPE_WTA_TABLE = 12,

    /**
     * @generated from enum value: FEATURETYPE_STATISTICS = 13;
     */
    FEATURETYPE_STATISTICS = 13,

    /**
     * @generated from enum value: FEATURETYPE_SQUAD = 20;
     */
    FEATURETYPE_SQUAD = 20,

    /**
     * @generated from enum value: FEATURETYPE_KEY_PLAYERS = 21;
     */
    FEATURETYPE_KEY_PLAYERS = 21,

    /**
     * @generated from enum value: FEATURETYPE_MISSING_PLAYERS = 22;
     */
    FEATURETYPE_MISSING_PLAYERS = 22,

    /**
     * @generated from enum value: FEATURETYPE_TOP_PLAYERS = 23;
     */
    FEATURETYPE_TOP_PLAYERS = 23,

    /**
     * @generated from enum value: FEATURETYPE_PERIOD_SCORES = 24;
     */
    FEATURETYPE_PERIOD_SCORES = 24,

    /**
     * @generated from enum value: FEATURETYPE_PLAY_BY_PLAY = 30;
     */
    FEATURETYPE_PLAY_BY_PLAY = 30,

    /**
     * @generated from enum value: FEATURETYPE_PREMATCH_STATS = 31;
     */
    FEATURETYPE_PREMATCH_STATS = 31,

    /**
     * @generated from enum value: FEATURETYPE_PLAYER_MATCH_STATS = 32;
     */
    FEATURETYPE_PLAYER_MATCH_STATS = 32,
  }
